import React, {useCallback} from 'react';

import debounce from 'lodash.debounce';

import {Textarea} from '@pb/kit-component-textarea-v2';
import {
    WysiwygEditor,
    additionalButtons,
    defaultToolbar,
    justifyGroupButtons,
    separator,
} from '@pb/kit-component-wysiwyg-editor';

type Props = {
    value: string,
    onChange: (value: string) => void,
    maxCharCount?: number,
    disabled?: boolean,
};

export const HtmlArea = ({value, onChange, maxCharCount = 512, disabled}: Props) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedChange = useCallback(debounce((newValue: string) => {
        onChange(newValue);
    }, 1000), []);

    return disabled ? (
        <Textarea disabled={disabled} value={value}/>
    ) : (
        <WysiwygEditor
            value={value}
            onChange={debouncedChange}
            config={{
                resize_enabled: true,
                toolbar: [
                    [
                        ...defaultToolbar,
                        additionalButtons.removeFormat,
                        separator,
                        additionalButtons.table,
                        separator,
                        additionalButtons.source,
                        separator,
                        additionalButtons.preview,
                        separator,
                        ...justifyGroupButtons,
                        separator,
                        additionalButtons.styles,
                        additionalButtons.format,
                        additionalButtons.font,
                        additionalButtons.fontSize,
                        additionalButtons.lineHeight,
                    ],
                ],
                extraPlugins: 'divarea,pastefromword,justify,font,preview,lineheight,wordcount',
                wordcount: {
                    showParagraphs: false,
                    showWordCount: false,
                    showCharCount: true,
                    countSpacesAsChars: true,
                    countHTML: true,
                    maxWordCount: -1,
                    maxCharCount,
                },
                startupFocus: false,
            }}
        />
    );
};

